import Reflux from 'reflux'

export default Reflux.createActions([
	'reload',
	'showModal',
	'hideModal',
	'setFilterLetter'
])



// WEBPACK FOOTER //
// ./src/actions/ingredients.js